export default __webpack_public_path__ + "static/media/Harness of the Refectory.8845c21c.jpg";